export default __webpack_public_path__ + "static/temporary-dumpster-rental-icon-e4e5866299d73b4355a5c7ba3b2ddc62.png";